import {ApprenticeshipModule} from '../model/apprenticeshipModule.model'
import {Company} from '../model/company.model'
import {Group} from '../model/group.model'
import {Apprentice, Person} from '../model/person.model'
import {TrialPeriodReport} from '../model/trialPeriodReport.model'

export const findCompanyById = (id: number | undefined, companies: Company[]): Company | undefined => {
	if (id === undefined || companies.length === 0) {
		return undefined
	}
	return companies?.find(data => data?.company_id === id)
}

export const findGroupById = (id: number | undefined, groups: Group[]): Group | undefined => {
	if (id === undefined || groups === undefined || groups.length === 0) {
		return undefined
	}
	return groups.find(data => data.group_id === id)
}

export const findPersonById = (id: number | undefined, persons: Person[]): Person | undefined => {
	if (id === undefined || persons === undefined || persons.length === 0) {
		return undefined
	}
	return persons.find(data => data.person_id === id)
}

export const findApprenticeById = (id: number | undefined, apprentices: Apprentice[])
	: Apprentice | undefined => {
	if (id === undefined || apprentices === undefined || apprentices.length === 0) {
		return undefined
	}
	return apprentices.find(data => data?.apprentice?.apprentice_id === id)
}

export const findTrialReportById = (id: number, trialPeriodReports: TrialPeriodReport[])
	: TrialPeriodReport | undefined => {
	return trialPeriodReports.find(data => data.trial_period_report_id === id)
}

export const findApprenticeshipModuleById = (id: number, apprenticeshipModules: any[])
	: any | undefined => {
	if (!apprenticeshipModules || apprenticeshipModules.length === 0) {
		return undefined
	}
	return apprenticeshipModules.find(data => data.apprenticeship_module_id === id)
}

// TODO replace any
export const findRoundingTypeById = (id: number, roundingTypes: any[])
	: any | undefined => {
	if (!roundingTypes || roundingTypes.length === 0) {
		return undefined
	}
	return roundingTypes.find(data => data.rounding_type_id === id)
}

export const findApprenticeshipModule = (id: number, apprenticeshipModules: ApprenticeshipModule[])
	: any | undefined => {
	if (!apprenticeshipModules || apprenticeshipModules.length === 0) {
		return undefined
	}
	return apprenticeshipModules.find(data => data.apprenticeship_module_id === id)
}